
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

interface PricingPlan {
  id: string;
  name: string;
  slug: string;
  price: number;
  features: string[];
  sort_order: number;
  is_active: boolean;
  stripe_price_id?: string;
}

export const usePricingPlans = () => {
  const [plans, setPlans] = useState<PricingPlan[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        logger.info("usePricingPlans", "Fetching pricing plans from database");
        
        // Use direct REST API call since subscription_plans table exists but isn't in generated types
        const SUPABASE_URL = "https://xyflmiuzahuywrmpvogq.supabase.co";
        const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh5ZmxtaXV6YWh1eXdybXB2b2dxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkyODM2NTYsImV4cCI6MjA1NDg1OTY1Nn0.rKwwyqWqatojkg6HYAzl43eMtfYXve2CFk2Kk9eHy9A";
        
        const response = await fetch(`${SUPABASE_URL}/rest/v1/subscription_plans?select=*&is_active=eq.true&order=sort_order.asc`, {
          headers: {
            'apikey': SUPABASE_KEY,
            'Authorization': `Bearer ${SUPABASE_KEY}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch subscription plans');
        }

        const fetchedData = await response.json();
        logger.info("usePricingPlans", "Plans fetched successfully", { count: fetchedData?.length });
        setPlans(fetchedData || []);
      } catch (err) {
        logger.error("usePricingPlans", "Exception in fetchPlans", err);
        setError(err instanceof Error ? err.message : 'Erro ao carregar planos');
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  return { plans, loading, error };
};
